<template>
  <div class="image-picker-root" :style="getRootStyle">
    <div class="form-label label-text" v-if="label">
      {{ $t(label) }}
      <span v-if="is_required" class="req-sign">*</span>
    </div>
    <validation-provider
      :name="name"
      :rules="rules"
      v-slot="{ errors, validate }"
    >
      <input
        type="file"
        class="d-none"
        ref="imageUploader"
        @change="(e) => fileChange(e, validate)"
        @click="resetImageUploader"
        :multiple="!single_upload"
        :accept="accept"
      />
      <div
        v-if="center_view"
        :class="[
          'picker-container',
          'text-center',
          { disabled: disabled ? true : false },
          {
            'invalid-picker-container':
              is_invalid || (errors && errors.length) || error_text
                ? true
                : false,
          },
        ]"
        :id="id"
        @click.stop="selectFile"
      >
        <div
          class="upload-icon d-flex justify-content-center align-items-center"
          style="margin: 0 auto"
        >
          <img
            :src="require('@/assets/images/icons/upload-icon.svg')"
            alt="upload-icon"
          />
        </div>
        <div class="placeholder-text">
          {{ placeholder }}
        </div>
        <div
          v-if="helper_text"
          :class="['helper-text']"
          :style="helper_text_style"
        >
          {{ $t(helper_text) }}
        </div>
        <div v-if="error_text" class="error-text">
          {{ error_text }}
        </div>
        <div v-if="errors && errors.length" class="error-text">
          {{ errors[0] }}
        </div>
      </div>
      <div
        v-else
        :class="[
          'picker-container',
          'd-flex',
          'justify-content-between',
          'align-items-center',
          { disabled: disabled ? true : false },
          {
            'invalid-picker-container':
              is_invalid || (errors && errors.length) || error_text
                ? true
                : false,
          },
        ]"
        :id="id"
        @click.stop="selectFile"
      >
        <div class="placeholder-text">
          {{ placeholder }}
        </div>
        <div
          class="upload-icon d-flex justify-content-center align-items-center"
        >
          <img
            :src="require('@/assets/images/icons/upload-icon.svg')"
            alt="upload-icon"
          />
        </div>
      </div>
      <div
        v-if="!center_view && helper_text"
        class="helper-text"
        :style="helper_text_style"
      >
        {{ $t(helper_text) }}
      </div>
      <div v-if="!center_view && error_text" class="error-text">
        {{ error_text }}
      </div>
      <div class="error-text" v-if="!center_view && errors && errors.length">
        {{ errors[0] }}
      </div>
    </validation-provider>
  </div>
</template>

<script>
export default {
  emits: ["change-value"],
  props: [
    "label",
    "placeholder",
    "is_invalid",
    "error_text",
    "helper_text",
    "helper_text_style",
    "field",
    "value",
    "cus_style",
    "remove_default_margin",
    "readOnly",
    "disabled",
    "cus_ref",
    "is_required",
    "options",
    "single_upload",
    "accept",
    "center_view",
    "rules",
    "name",
    "id",
  ],
  methods: {
    selectFile() {
      if (this.$refs && this.$refs.imageUploader)
        this.$refs.imageUploader.click();
    },
    async fileChange(e, validate) {
      const res = await validate(e);
      if (res.valid) this.$emit("change-value", e.target.files, this.field);
    },
    resetImageUploader() {
      this.$refs.imageUploader.value = "";
    },
  },
  computed: {
    getRootStyle() {
      return `margin-bottom: ${
        this.remove_default_margin ? "0px" : "20px"
      };position:relative;`;
    },
  },
};
</script>

<style lang="scss" scoped>
.label-text {
  font-size: 14px;
  color: var(--color-61);
  margin-bottom: 5px;
  font-weight: 700;
}

.picker-container {
  cursor: pointer;
  border: 2px dashed;
  border-color: var(--color-04);
  border-radius: 4px;
  padding: 5px 20px;
}

.disabled {
  background-color: var(--color-67) !important;
  pointer-events: none;
}
.invalid-picker-container {
  border-color: var(--color-47) !important;
}

.placeholder-text {
  font-weight: 400;
  font-size: 12px;
  color: var(--color-66);
}

.upload-icon {
  height: 40px;
  width: 40px;
  border-radius: 50%;
  background: var(--color-11);
}
</style>
